import Controller from "./locationTrackingMap.controller";
import template from "./locationTrackingMap.html";

const locationTrackingMap = {
  template,
  controller: Controller,
  bindings: {
    pastStations: "<",
    comingStations: "<",
    ride: "<",
    schedule: "<",
    polyline: "<",
  },
};

export default locationTrackingMap;



// WEBPACK FOOTER //
// ./src/components/locationTrackingMap/locationTrackingMap.component.js